<template>
  <div>
    <div class="tabs">
      <div
        v-for="item in filteredTabs"
        :key="`show` + item.id"
        :class="{ active: activeTab === item.value }"
        @click="setActiveTab(item.value)"
      >
        <p>{{ item.label }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ShowPlansType } from "@/store/types";
import { authMixin } from "@/mixins/authMixin";

export default {
  props: ["activeTab"],
  mixins: [authMixin],
  data() {
    return {};
  },
  computed: {
    tabs() {
      return [
        {
          id: 0,
          label: this.$t("staking.stakingPlans.tab_1"),
          value: ShowPlansType.ALL_PLANS,
          show: true
        },
        {
          id: 1,
          label: this.$t("staking.stakingPlans.tab_2"),
          value: ShowPlansType.MY_PLANS,
          show: this.isAuth
        }
      ];
    },
    filteredTabs() {
      return this.tabs.filter(item => item.show);
    }
  },
  methods: {
    setActiveTab(value) {
      this.$emit("setActiveTab", value);
    }
  }
};
</script>

<style scoped lang="scss">
.tabs {
  border-bottom: 1px solid var(--v-primary6-base);
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  gap: 20px;

  & > div {
    cursor: pointer;
  }
}

.active {
  border-bottom: 2px solid var(--v-primary-base);
}
</style>
